import { Avatar, Button } from "@mui/material";
import React from "react";
import { FlexCenter } from "../../../../constant/CustomeStyle";
import UploadIcon from "../../../../../assets/images/upload-icon.png";

const ImageUpload = () => {
  let [images, setImages] = React.useState([]);

  //profile pic upload
  const hiddenProfilePicFileInput = React.useRef(null);

  const handleUploadProfilePic = (event) => {
    hiddenProfilePicFileInput.current.click();
  };

  const uploadImage = (event) => {
    let fileUploaded = event.target.files[0];

    let reader = new FileReader();
    let url = reader.readAsDataURL(fileUploaded);

    reader.onloadend = function (e) {
      setImages({ imgSrc: [reader.result] });
      //   setImages([...images, { imgSrc: [reader.result] }]);
    };

    // let newName = new Date().getTime() + event.target.files[0].name;
    // let new_file = new File([fileUploaded], newName);
  };

  return (
    <div>
      <FlexCenter style={{ marginBottom: 10 }}>
        {images.imgSrc && (
          <img style={{ width: 100, height: 100 }} src={images.imgSrc} />
        )}
      </FlexCenter>

      <FlexCenter>
        <input
          type="file"
          ref={hiddenProfilePicFileInput}
          onChange={uploadImage}
          style={{ display: "none" }}
        />
        <Avatar
          sx={{
            width: 50,
            height: 50,
            cursor: "pointer",
          }}
          variant="square"
          src={UploadIcon}
          onClick={handleUploadProfilePic}
        />
      </FlexCenter>
      <div
        style={{
          marginTop: 5,
          fontSize: 12,
          fontFamily: "Roboto, sans-serif",
          fontWeight: "500",
          color: "#424242",
        }}
      >
        Upload Product Image
      </div>
    </div>
  );
};

export default ImageUpload;
